import React, { useState } from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { showSuccessToast } from '../../utils/errorHandling';
import BulkUploadModal from '../shared/BulkUploadModal';

const BulkUpload = () => {
  const navigate = useNavigate();
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(true);

  const handleBulkUploadComplete = (result) => {
    showSuccessToast(`Bulk upload completed: ${result.successCount} draft questions uploaded`);
    navigate('/content-generator/my-questions');
  };

  const handleClose = () => {
    setShowBulkUploadModal(false);
    navigate('/content-generator/my-questions');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <button
                onClick={() => navigate('/content-generator/my-questions')}
                className="mr-4 p-2 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div className="flex items-center">
                <FileText className="w-6 h-6 text-blue-600 mr-3" />
                <h1 className="text-xl font-semibold text-gray-900">Bulk Upload Draft Questions</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="mb-6">
            <h2 className="text-lg font-medium text-gray-900 mb-2">Bulk Upload Draft Questions</h2>
            <p className="text-sm text-gray-600">
              Upload multiple draft questions from an Excel file. These questions will be reviewed by content reviewers and approved by content supervisors before becoming published questions.
            </p>
          </div>

          <button
            onClick={() => setShowBulkUploadModal(true)}
            className="w-full px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center justify-center"
          >
            <FileText className="w-5 h-5 mr-2" />
            Start Bulk Upload
          </button>
        </div>
      </div>

      {/* Bulk Upload Modal */}
      <BulkUploadModal
        isOpen={showBulkUploadModal}
        onClose={handleClose}
        onSubmit={handleBulkUploadComplete}
        isDraft={true}
        title="Bulk Upload Draft Questions"
        uploadEndpoint="/api/super-admin/draft-questions/upload-csv"
      />
    </div>
  );
};

export default BulkUpload;
